import React from "react";
import { Link } from "react-router-dom";
import { Logo } from "@/components/Logo";

export function Footer() {
  return (
    <footer className="border-t border-white/5 bg-slate-950 px-4 py-12 sm:px-6">
      <div className="mx-auto max-w-6xl">
        <div className="flex flex-col items-start justify-between gap-8 md:flex-row">
          <div className="max-w-sm">
            <Logo />
            <p className="mt-4 text-sm leading-relaxed text-slate-400">
              Transforme o que você precisa em algo pronto para usar.
            </p>
          </div>

          <nav className="flex flex-col gap-3">
            <span className="text-xs font-semibold uppercase tracking-wider text-slate-500">
              Links
            </span>
            <Link to="/termos" data-testid="footer-terms-link" className="text-sm text-slate-300 hover:text-white no-underline">
              Termos de Uso
            </Link>
            <Link to="/privacidade" data-testid="footer-privacy-link" className="text-sm text-slate-300 hover:text-white no-underline">
              Política de Privacidade
            </Link>
            <Link to="/contato" data-testid="footer-contact-link" className="text-sm text-slate-300 hover:text-white no-underline">
              Contato
            </Link>
          </nav>
        </div>

        <div className="mt-10 rounded-2xl border border-white/5 bg-white/[0.02] p-5">
          <p className="text-xs leading-relaxed text-slate-500">
            O Pronto.AI é uma ferramenta de apoio para criação de textos e instruções. Os
            resultados podem variar conforme a ferramenta de IA utilizada. O Pronto.AI não
            possui afiliação com OpenAI, Anthropic ou Google.
          </p>
        </div>

        <p className="mt-8 text-center text-xs text-slate-600">
          © {new Date().getFullYear()} Pronto.AI — Todos os direitos reservados.
        </p>
      </div>
    </footer>
  );
}
